// TODO: From App New
<template>
  <div class="d-flex align-items-center w-100">
    <!-- Brand Avatar -->
    <div class="flex-shrink-0 mr-1">
      <b-avatar
        v-if="selectedBrand"
        :src="selectedBrand.image_url"
        :text="selectedBrand.name.charAt(0)"
        size="48"
        variant="light-primary"
      />
      <b-avatar
        v-else
        size="48"
        variant="light-secondary"
      >
        <feather-icon
          icon="ImageIcon"
          size="20"
        />
      </b-avatar>
    </div>

    <!-- Title & Description -->
    <div class="flex-grow-1">
      <h4 class="mb-50">
        {{ (selectedBrand && selectedBrand.name) || '' }}
      </h4>
      <small class="text-muted d-flex align-items-center">
        Atur harga promo untuk brand ini
        <!-- Saving Status Indicator -->
        <span
          v-if="autoSaveEnabled && savingStatus"
          class="ml-2"
        >
          <small
            :class="{
              'text-muted': savingStatus === 'saving',
              'text-success': savingStatus !== 'saving'
            }"
            class="d-inline-flex align-items-center"
          >
            <b-spinner
              v-if="savingStatus === 'saving'"
              small
              class="mr-50"
            />
            <feather-icon
              v-else
              icon="CheckIcon"
              size="14"
              class="mr-50"
            />
            {{ savingStatus === 'saving' ? 'Menyimpan...' : 'Perubahan disimpan' }}
          </small>
        </span>
      </small>
    </div>

    <!-- Action Button - Far Right -->
    <div class="ml-auto d-flex align-items-center">
      <!-- Auto Save Checkbox -->
      <div
        v-if="showAutoSaveToggle"
        class="mr-1"
      >
        <b-form-checkbox
          :checked="autoSaveEnabled"
          name="auto-save-checkbox"
          switch
          inline
          class="mr-50"
          @change="$emit('toggle-auto-save', $event)"
        >
          <small class="text-muted">Auto Simpan</small>
        </b-form-checkbox>
      </div>

      <!-- Save Button -->
      <button
        v-if="showSaveButton"
        class="btn btn-primary d-flex align-items-center"
        :disabled="!hasProducts || loadingSubmit"
        @click="$emit('save-and-finish')"
      >
        <b-spinner
          v-if="loadingSubmit"
          small
          class="mr-50"
        />
        Simpan dan Selesai
      </button>
    </div>
  </div>
</template>

<script>
import { BAvatar, BFormCheckbox, BSpinner } from 'bootstrap-vue'

export default {
  name: 'BrandSetupToolbar',
  components: {
    BAvatar,
    BFormCheckbox,
    BSpinner,
  },
  props: {
    selectedBrand: {
      type: Object,
      default: null,
    },
    autoSaveEnabled: {
      type: Boolean,
      default: false,
    },
    hasProducts: {
      type: Boolean,
      default: false,
    },
    loadingSubmit: {
      type: Boolean,
      default: false,
    },
    savingStatus: {
      type: String,
      default: null,
      validator: value => !value || ['saving', 'saved'].includes(value),
    },
    showSaveButton: {
      type: Boolean,
      default: true,
    },
    showAutoSaveToggle: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['toggle-auto-save', 'save-and-finish'],
}
</script>
